import { render, staticRenderFns } from "./PartnerHeader.vue?vue&type=template&id=6c994a70&scoped=true&"
import script from "./PartnerHeader.vue?vue&type=script&lang=js&"
export * from "./PartnerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PartnerHeader.vue?vue&type=style&index=0&id=6c994a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c994a70",
  null
  
)

export default component.exports